import { BaseProperties } from "./base.interface";

export enum PaymentDetailsMethod {
  PIX = "PIX",
  CASH = "CASH",
  CREDIT_CARD = "CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
  ZELLE = "ZELLE",
}

export interface PaymentsInput {
  orderId: string;
  method: PaymentDetailsMethod;
  paymentDate: Date;
  amount: number;
}

export interface PaymentsOutput extends BaseProperties, PaymentsInput {}

export const orderPaymentDetailsMethodTranslations: Record<
  PaymentDetailsMethod,
  string
> = {
  [PaymentDetailsMethod.CASH]: "Dinheiro",
  [PaymentDetailsMethod.PIX]: "PIX",
  [PaymentDetailsMethod.CREDIT_CARD]: "Cartão de crédito",
  [PaymentDetailsMethod.DEBIT_CARD]: "Cartão de débito",
  [PaymentDetailsMethod.ZELLE]: "Zelle",
};
